export class ConveyanceCommunityTransferAccountRawDto {
    transferAccountCommunityIds: number[];
}
